module.exports = __webpack_public_path__ + "static/ruby-288ac636a508b903ef1d5c8c914a531c.png";